<template>
  <ModalElement
    v-if="showModal"
    name="cancel-modal"
    icon="warning"
    width="560"
    :close-button="true"
    :click-to-close="true"
    :show="true"
    @modalVisible="showModal = $event"
  >
    <div class="modal-content">
      <div class="modal-content__alert">
        <icon
          class="modal-content__alert__svg"
          :icon="icon"
        />
        <p class="modal-content__alert__text">
          Houve um erro ao enviar seus documentos
        </p>
      </div>
      <div class="modal-content__message">
        <p
          class="modal-content__message__text"
        >
          Tente novamente ou reveja seus documentos.
        </p>
      </div>
    </div>
  </ModalElement>
</template>

<script>
import '@/assets/sass/project/_select.scss';
import { mapActions } from 'vuex';
import ModalElement from '@/components/common/ModalElement.vue';

export default {
  name: 'ErrorModal',
  components: {
    ModalElement,
  },
  props: {
    icon: {
      type: String,
      default: 'Warning'
    },
  },

  data() {
    return {
      showModal: true,
    };
  },

  watch: {
    showModal(){
      if(!this.showModal) {
        this.$emit('toogleModal');
        this.clearModalToShow();
      }
    }
  },

  methods: {
    ...mapActions([
      'clearModalToShow',
    ]),
  }
};
</script>

<style lang="scss" scoped>
.modal-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: 0.5rem;
  padding: 1.2rem 0 1.6rem 0;

  &__alert {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: $white;

    &__text {
      @include text-xl(2);
    }

    &__svg {
      margin-bottom: 1.2rem;
      width: 4rem;
      color: $orange-text;
    }
  }

  &__message {
    padding: 0.5rem 1rem 0;
    text-align: center;
    margin-bottom: 1.5rem;

    &__text {
      @include text-m(1,2);

      text-align: center;
    }
  }

  &__select {
    width: 32rem;
    margin-bottom: 2rem;

    @include screen (phone-only) {
      width: 100%;
    }

    @include screen (tablet-only) {
      width: 100%;
    }
  }

  &__mainBtn {
    width: 10.5rem;
    margin-bottom: 1.5rem;
  }

  &__secondaryBtn {
    width: 20.5rem;
  }
}
</style>
